export default __webpack_public_path__ + "static/media/lock.fe0466bd.svg";